import { createAsyncThunk } from "@reduxjs/toolkit";
import TicketDataEditorAPI, { TicketDataEditorApiUrls } from "../API/TicketDataEditorAPI";

import LocalStorage from "../../../../Services/Storage/LocalStorage";
import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const ticketDataEditorAPI = new TicketDataEditorAPI(apiHelper, cache);

export const getTicketForFallback = createAsyncThunk(
  TicketDataEditorApiUrls.getTicketForFallback,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await ticketDataEditorAPI.getTicketForFallback(payload, token);

    return response;
  }
);
export const updateTicketForFallback = createAsyncThunk(
  TicketDataEditorApiUrls.updateTicketForFallback,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await ticketDataEditorAPI.updateTicketForFallback(payload, token);

    return response;
  }
);

export const updateTicketDeadlineForFallback = createAsyncThunk(
  TicketDataEditorApiUrls.updateTicketDeadlineForFallback,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await ticketDataEditorAPI.updateTicketDeadlineForFallback(payload, token);

    return response;
  }
);

export const refreshApplicationResultForFallback = createAsyncThunk(
  TicketDataEditorApiUrls.refreshApplicationResultForFallback,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await ticketDataEditorAPI.refreshApplicationResultForFallback(payload, token);

    return response;
  }
);
